import PictureIcon from '@/shared/assets/icons/picture.svg?react'
import { BaseButton, FileModal } from '@/shared/components'
import { formatDate } from '@/shared/lib/date'
import { formatBytes, getBase64FileSize, getLinkName } from '@/shared/utils/downloadfile'
import { useState } from 'react'
import { DisputModel } from '../../model/types'

export const DownloadPicture = ({ disput }: { disput: DisputModel }) => {
  const [modalVisible, setModalVisible] = useState(false)

  const handleView = () => {
    if (disput.receiptFile && disput.receiptType) {
      setModalVisible(true)
    }
  }

  // const handleDownload = (e: React.MouseEvent) => {
  //   e.stopPropagation()
  //   if (disput.receiptFile && disput.receiptType) {
  //     const extension = disput.receiptType.split('/')[1] ?? 'bin'
  //     downloadBase64File({
  //       base64: disput.receiptFile,
  //       mimeType: disput.receiptType,
  //       filename: `receipt.${extension}`,
  //     })
  //   }
  // }

  return (
    <>
      {disput.receiptFile ? (
        <BaseButton
          variant="transparent"
          padding="xs"
          className="flex items-center gap-[10px] text-left font-medium min-w-max"
          onClick={handleView}
        >
          <PictureIcon className="text-[var(--status-purple-fill)] dark:text-[var(--status-purple-fill)] shrink-0" />
          <div className="flex flex-col">
            <span className="font-medium">
              {disput.receiptType ? getLinkName(disput.receiptType) : 'Документ'}
            </span>
            <span className="text-sm text-text-secondary">
              {formatBytes(getBase64FileSize(disput.receiptFile))} {formatDate(disput.createdAt)}
            </span>
          </div>
        </BaseButton>
      ) : (
        <div className="flex items-center gap-[10px]">
          <PictureIcon className="text-[var(--status-purple-fill)] dark:text-[var(--status-purple-fill)] shrink-0" />
          <span className="font-medium">Прикрепленных документов нет</span>
        </div>
      )}

      <FileModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        receiptFile={disput.receiptFile}
        receiptType={disput.receiptType}
      />
    </>
  )
}
